export var SHARK_EVENTS;
(function (SHARK_EVENTS) {
    SHARK_EVENTS["LOGIN_SUCCESS_ACT"] = "login_success_act";
    SHARK_EVENTS["ACT_SHARE_SUCCESS"] = "act_share_success";
    SHARK_EVENTS["ACT_SHARE_FAIL"] = "act_share_failed";
    SHARK_EVENTS["ACT_H5_OPEN"] = "act_H5_open";
    SHARK_EVENTS["ACT_H5_CLOSE"] = "act_H5_close";
    SHARK_EVENTS["ACT_DOWNLOAD_START"] = "act_download_start";
    SHARK_EVENTS["ACT_DOWNLOAD_SUCCESS"] = "act_download_success";
})(SHARK_EVENTS || (SHARK_EVENTS = {}));
export var INF_FROM;
(function (INF_FROM) {
    INF_FROM[INF_FROM["TOUTIAO"] = 0] = "TOUTIAO";
    INF_FROM[INF_FROM["DOUYIN"] = 2] = "DOUYIN";
    INF_FROM[INF_FROM["HUOSHAN"] = 3] = "HUOSHAN";
    INF_FROM[INF_FROM["XIGUA"] = 4] = "XIGUA";
    INF_FROM[INF_FROM["PIPIXIA"] = 5] = "PIPIXIA";
    INF_FROM[INF_FROM["GAME"] = 6] = "GAME";
    INF_FROM[INF_FROM["WEIXIN"] = 7] = "WEIXIN";
    INF_FROM[INF_FROM["QQ"] = 8] = "QQ";
    INF_FROM[INF_FROM["UNKNOWN"] = -1] = "UNKNOWN";
})(INF_FROM || (INF_FROM = {}));
export var BROWSER_TYPE;
(function (BROWSER_TYPE) {
    BROWSER_TYPE[BROWSER_TYPE["GAME"] = 1] = "GAME";
    BROWSER_TYPE[BROWSER_TYPE["WEIXIN"] = 2] = "WEIXIN";
    BROWSER_TYPE[BROWSER_TYPE["UC"] = 3] = "UC";
    BROWSER_TYPE[BROWSER_TYPE["SAFARI"] = 4] = "SAFARI";
    BROWSER_TYPE[BROWSER_TYPE["CHROME"] = 5] = "CHROME";
    BROWSER_TYPE[BROWSER_TYPE["OPPO"] = 6] = "OPPO";
    BROWSER_TYPE[BROWSER_TYPE["XIAOMI"] = 7] = "XIAOMI";
    BROWSER_TYPE[BROWSER_TYPE["VIVO"] = 8] = "VIVO";
    BROWSER_TYPE[BROWSER_TYPE["HUAWEI"] = 9] = "HUAWEI";
    BROWSER_TYPE[BROWSER_TYPE["QQ"] = 10] = "QQ";
    BROWSER_TYPE[BROWSER_TYPE["OPEN"] = 11] = "OPEN";
    BROWSER_TYPE[BROWSER_TYPE["OTHER"] = 12] = "OTHER";
})(BROWSER_TYPE || (BROWSER_TYPE = {}));
export function getAppType() {
    var UA = navigator.userAgent;
    switch (true) {
        case /(NewsArticle)[\s/_](\d.\d.\d)/i.test(UA):
            return INF_FROM.TOUTIAO;
        case /aweme_\d+/i.test(UA):
            return INF_FROM.DOUYIN;
        case /live_stream_\d+/i.test(UA):
            return INF_FROM.HUOSHAN;
        case /VideoArticle/i.test(UA):
            return INF_FROM.XIGUA;
        case /Super \d.\d.\d/i.test(UA):
            return INF_FROM.PIPIXIA;
        case /BDGameSDK/i.test(UA):
            return INF_FROM.GAME;
        case /MicroMessenger/i.test(UA):
            return INF_FROM.WEIXIN;
        case / QQ/i.test(UA):
            return INF_FROM.QQ;
        default:
            return INF_FROM.UNKNOWN;
    }
}
export function getBrowserType() {
    var UA = navigator.userAgent;
    switch (true) {
        case /BDGameSDK/i.test(UA):
            return BROWSER_TYPE.GAME;
        case /MicroMessenger/i.test(UA):
            return BROWSER_TYPE.WEIXIN;
        case /UBrowser/i.test(UA):
            return BROWSER_TYPE.UC;
        case /Chrome/i.test(UA) && /Safari/i.test(UA):
            return BROWSER_TYPE.CHROME;
        case /Safari/i.test(UA):
            return BROWSER_TYPE.SAFARI;
        case /oppo/i.test(UA):
            return BROWSER_TYPE.OPPO;
        case /vivo/i.test(UA):
            return BROWSER_TYPE.VIVO;
        case /huawei/i.test(UA):
            return BROWSER_TYPE.HUAWEI;
        case /MQQBrowser/i.test(UA):
            return BROWSER_TYPE.QQ;
        case /Opera/i.test(UA):
            return BROWSER_TYPE.OPEN;
        default:
            return BROWSER_TYPE.OTHER;
    }
}
export function getLoginType() {
    var inf_from = getAppType();
    if (inf_from === INF_FROM.GAME) {
        return 'gsdk';
    }
    return 'passport';
}
//# sourceMappingURL=tools.js.map